import service from '@/utils/axios'
export function getWxSign(params) {
  return service.get('https://www.suxinwen.cn/wechat/js_api', params)
}

export function login(params) {
  return service.post('/v4/shopmall/auto-login', params)
}

export function getQRCode(params) {
  return service.post('/v4/shopmall/get-qrcode', params)
}

export function getHistoryList(params) {
  return service.get('/v4/news/hot-dynamic-screens', { params })
}
